import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { SiffiLanguagePickerComponent } from '../../../components/siffi-language-picker/siffi-language-picker.component';
import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import AppLanguageService from '../../../services/app-language.service';
import Config from '../../../utils/config.service';

@Component({
	standalone: true,
	selector: 'partner-signup-success',
	templateUrl: './partner-signup-success.component.html',
	styleUrl: './partner-signup-success.component.scss',
	imports: [CommonModule, TranslateUnauthenticatedPipe, SiffiLanguagePickerComponent]
})
export default class PartnerSignupSuccessComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);

	private titleSubscription?: Subscription;

	product: string = 'SIFFI';
	headerClass: string = 'o-container c-container';
	origin: string = 'siffi.com';
	locale: string = 'en_GB';
	locales: Array<any> = [];
	logoSuffix: string = 'en';
	langOpen: boolean = false;
	firstName: string = '';

	ngOnInit() {
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		this.determineLocation(queryParams);
		this.locale = this.appLanguageService.normalizeLocale(queryParams['locale'] || window.sessionStorage.getItem('locale') || 'en_GB');
		window.sessionStorage.setItem('locale', this.locale);
		this.firstName = queryParams['firstName'] || '';
		this.locales = this.appLanguageService.getLanguagesByOrigin(this.origin);
		this.logoSuffix = this.resolveLogoSuffix(this.locale);

		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('PartnerSignupSuccess.Page_Title');
	}

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}

	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}

	toggleLangMenu() {
		this.langOpen = !this.langOpen;
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}

	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl(this.origin, this.locale);
	}

	private determineLocation(queryParams) {
		var host: any = window.location.hostname;
		var url: any = window.location.href;
		if (host.includes('minudoc')) {
			this.origin = queryParams['origin'] || 'minudoc.ee';
			this.product = url.includes('eelvisiit') ? 'PREVISIT' : 'MINUDOC';
			this.headerClass = '';
			return;
		}
		this.origin = queryParams['origin'] || 'siffi.com';
		this.product = 'SIFFI';
		this.headerClass = 'o-container c-container';
	}

	private resolveLogoSuffix(locale: string) {
		var normalizedLocale: any = this.appLanguageService.normalizeLocale(locale);
		var languageCode: any = (normalizedLocale || 'en_GB').split('_')[0];
		if (['en', 'et', 'ru', 'fi'].indexOf(languageCode) === -1) {
			return 'en';
		}
		return languageCode;
	}
}
